__turbopack_context__.v({
  "articleContent": "SingleArticleCard-module-scss-module__TQfKjG__articleContent",
  "bottomHalf": "SingleArticleCard-module-scss-module__TQfKjG__bottomHalf",
  "description": "SingleArticleCard-module-scss-module__TQfKjG__description",
  "favoriteButtonPrimary": "SingleArticleCard-module-scss-module__TQfKjG__favoriteButtonPrimary",
  "favoriteButtonSecondary": "SingleArticleCard-module-scss-module__TQfKjG__favoriteButtonSecondary",
  "image": "SingleArticleCard-module-scss-module__TQfKjG__image",
  "imageLink": "SingleArticleCard-module-scss-module__TQfKjG__imageLink",
  "imageWrapper": "SingleArticleCard-module-scss-module__TQfKjG__imageWrapper",
  "primary": "SingleArticleCard-module-scss-module__TQfKjG__primary",
  "primaryBottom": "SingleArticleCard-module-scss-module__TQfKjG__primaryBottom",
  "roundedImage": "SingleArticleCard-module-scss-module__TQfKjG__roundedImage",
  "secondaryBottom": "SingleArticleCard-module-scss-module__TQfKjG__secondaryBottom",
  "singleArticleCard": "SingleArticleCard-module-scss-module__TQfKjG__singleArticleCard",
  "tags": "SingleArticleCard-module-scss-module__TQfKjG__tags",
  "title": "SingleArticleCard-module-scss-module__TQfKjG__title",
});
